import FadeInSection from '../../../components/feature/FadeInSection';

const steps = [
  {
    number: 'STEP 1',
    title: '無料相談',
    icon: 'ri-chat-smile-line',
    color: '#e8934e',
    bg: '#fff8f2',
    descriptions: [
      '入会前に、システム、サービス、料金について十分にご理解いただきたいとの思いから、無料相談を行っています。',
      '悩みごと、不安に思うこと、質問にも丁寧にお答えします。',
      'どのように活動をして、お相手を探していくのか、あなたに合った方法を一緒に考えていきましょう。',
    ],
    image:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/service-flow-1.jpeg',
  },
  {
    number: 'STEP 2',
    title: '入会手続き',
    icon: 'ri-file-text-line',
    color: '#5a9e6f',
    bg: '#f2f8f4',
    descriptions: [
      '全てご納得いただいてから、入会手続きをさせていただきます。無理な勧誘やセールスは一切しませんのでご安心ください。',
      '信頼できる会員情報を提供するためにも、全ての会員の方には入会に必要な書類をご準備またご提出いただいています。',
      'お相手探しに大事なプロフィール作成も会員様の魅力を最大限伝わる内容でプロのカウンセラーが担当します。',
      '会員登録完了次第、会員ID・パスワードを発行し、お相手検索システムのご利用が可能となり、活動スタートとなります。',
    ],
    image:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/service-flow-2.png',
  },
  {
    number: 'STEP 3',
    title: 'お相手探し・お見合い',
    icon: 'ri-user-search-line',
    color: '#e8934e',
    bg: '#fff8f2',
    descriptions: [
      '多くの会員の中からご自身の希望条件に合う方をお相手検索システムよりいつでもどこでもお探しいただけます。',
      '気になるお相手がいたらお見合い申し込みを積極的にしてください。お相手からのお見合い申し受けもあります。',
      '定期的にご希望に沿うお相手をカウンセラーより個別ご推薦紹介もいたします。',
      '双方がお会いしたいと思えば、「お見合い」となります。お見合い時間は約1時間で、ホテルラウンジなどでお茶をしてお話いただきます。',
    ],
    image:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/service-flow-3.jpeg',
  },
  {
    number: 'STEP 4',
    title: '交際',
    icon: 'ri-heart-line',
    color: '#5a9e6f',
    bg: '#f2f8f4',
    descriptions: [
      'お見合い後、お互いお相手を気に入りましたら、連絡先交換となり、仮交際（プレ交際）スタートとなります。',
      '積極的にデートに誘い、お互いの仲をより深めてください。',
      '交際中は、交際しているお相手と向き合いおふたりの理解を深める大切な時間です。',
    ],
    image:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/service-flow-4.jpeg',
  },
  {
    number: 'STEP 5',
    title: '成婚',
    icon: 'ri-heart-2-line',
    color: '#c0614a',
    bg: '#fff5f3',
    descriptions: [
      'お二人の結婚、パートナーシップの意思が固まりましたらご報告ください。',
      'お互いの結婚の意思確認ができましたら、晴れて成婚退会の運びとなります。',
      'ご成婚おめでとうございます。',
    ],
    image:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/service-flow-5.png',
  },
];

export default function ServiceFlowSection() {
  return (
    <section className="section-padding" style={{ background: '#fffaf6' }}>
      <div className="content-width">
        <FadeInSection className="text-center mb-16">
          <p
            className="inline-block px-4 py-1 rounded-full mb-4 text-sm font-bold"
            style={{ background: '#fff8f2', color: '#8b4513', border: '1px solid #d4a574' }}
          >
            5つのステップ
          </p>
          <h2 style={{ color: '#4a3728' }}>ご縁が繋がるまでの流れ</h2>
          <p style={{ color: '#6b5a4e', marginTop: '12px', fontSize: '17px' }}>
            あなたのペースに合わせて、カウンセラーが最後まで丁寧にサポートいたします
          </p>
        </FadeInSection>

        <div className="space-y-16">
          {steps.map((step, index) => (
            <FadeInSection key={step.number} delay={index * 80}>
              <div
                className={`flex flex-col lg:flex-row items-center gap-10 ${
                  index % 2 !== 0 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                {/* Image */}
                <div className="w-full lg:w-[460px] shrink-0">
                  <div className="w-full h-[280px] md:h-[320px] rounded-2xl overflow-hidden">
                    <img
                      src={step.image}
                      alt={step.title}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  {/* Step badge */}
                  <div className="flex items-center gap-3 mb-5">
                    <span
                      className="inline-block px-4 py-1.5 rounded-full text-sm font-bold text-white"
                      style={{ background: step.color }}
                    >
                      {step.number}
                    </span>
                  </div>

                  {/* Title */}
                  <div className="flex items-center gap-3 mb-5">
                    <span
                      className="flex items-center justify-center w-11 h-11 rounded-full shrink-0"
                      style={{ background: step.bg }}
                    >
                      <i
                        className={`${step.icon} text-2xl`}
                        style={{ color: step.color }}
                      ></i>
                    </span>
                    <h3 style={{ color: '#4a3728', fontSize: '26px', fontWeight: '700' }}>
                      {step.title}
                    </h3>
                  </div>

                  {/* Descriptions */}
                  <ul className="space-y-3">
                    {step.descriptions.map((desc, i) => (
                      <li key={i} className="flex items-start gap-2.5">
                        <span
                          className="mt-1.5 w-2 h-2 rounded-full shrink-0"
                          style={{ background: step.color }}
                        ></span>
                        <p style={{ color: '#6b5a4e', lineHeight: '1.85', fontSize: '16px' }}>
                          {desc}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* Connector arrow (not last item) */}
              {index < steps.length - 1 && (
                <div className="flex justify-center mt-10">
                  <div
                    className="flex items-center justify-center w-10 h-10 rounded-full"
                    style={{ background: '#e8d8cc' }}
                  >
                    <i className="ri-arrow-down-line text-xl" style={{ color: '#8b4513' }}></i>
                  </div>
                </div>
              )}
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}
